import { pageConfig } from '@/common/service/page-config';
import _ from 'lodash';
import { planTypes, trackingPlanTypes } from '@/common/constants';
import { partnerReferImageFileMap } from '@/views/config/partner-refer/helper/constant';
import { isEmptyVal } from '@/utils';

/**
 *
 * @return {PartnerReferBean}
 */
export const getPartnerRefer = () => {
  return pageConfig.partnerReferral ?? {};
};

/**
 * @description get all tracking plan names for partner promotion
 * @param planList
 * @param groupByPlanCodePlanMap
 * @return {string}
 */
export const getTrackingPlanNames = (planList, groupByPlanCodePlanMap = {}) => {
  return _.chain(planList)
    .reduce((pre, planCode) => {
      const { type, category } = _.get(groupByPlanCodePlanMap, [planCode], {});

      const planTypeKey = planTypes[type];
      const planName = trackingPlanTypes[planTypeKey] ?? type;
      const trackingName = (planName || category) ? `${planName} ${category}` : ''

      return [...pre, trackingName];
    }, [])
    .filter(Boolean)
    .join(',')
    .value();
}

/**
 *
 * @returns {*|{offerDetailLogo: string, offerPreloadFeature: string, planCardLogo: string}}
 */
export const getPartnerImageFileInfo = (partnerReferInfo) => {
  const partnerRefer = partnerReferInfo ?? getPartnerRefer();
  const partnerName = partnerRefer?.partnerName?.toLowerCase();

  return partnerReferImageFileMap?.[partnerName] || {
    planCardLogo: '',
    offerDetailLogo: '',
    offerPreloadFeature: '',
  };
};

export const replaceOfferDetailWithImageLink = (content = '', pattern, imgFileLink = '') => {
  const partnerRefer = getPartnerRefer();

  if (partnerRefer.features?.containDynamicImageFile) {
    return imgFileLink ? _.chain(content)
      .replace(pattern, imgFileLink)
      .value() : content;
  }

  return content;
}

export const createLoadingPlaceholder = (style = "margin-right: 8px;") => `<span style="${style}"><i class="zm-icon-loading" ></i></span>`;

export const isFromPartnerCampaign = () => {
  return isEmptyVal(window.$config?.('partnerReferral')) === false;
}
